import http from '../_http'

const detect = {
  //default
  summaryDetect: (m) => { return http.post(`manager/wmds/detect/summary`, m); },
  listDetect: (m) => { return http.post(`manager/wmds/detect/list`, m); },
  detailDetect: (m) => { return http.get(`manager/wmds/detect/${m.id}`); },

  //crud
  deleteDetect: (m) => { return http.delete(`manager/wmds/detect/${m.id}`); },
}

export default detect

export { detect }